import useUser from '@cobliteam/hooks/src/useEntity/useUser';
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import type { ReactNode } from 'react';
import { createIDBPersister } from '../persister/createPersister';

// Client isolado do app: o cache da busca global vive no IndexedDB e revalida so por
// acao explicita — abrir o modal ou clicar em "Atualizar dados da frota". Sem estes
// overrides valem os defaults do TanStack (staleTime 0 + refetch on focus/mount/reconnect),
// e as 5 queries da frota disparavam a cada foco de janela depois da primeira abertura.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24, // 1 day
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      retry: 1,
    },
  },
});

const ProviderPersistQueryClient = ({ children }: { children: ReactNode }) => {
  const { user, getSession } = useUser();
  const session = getSession();
  const persister = createIDBPersister(`v1_${session?.fleet.id}_${user?.id}`);
  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
      {children}
    </PersistQueryClientProvider>
  );
};

export { ProviderPersistQueryClient, queryClient };
